// extracted by mini-css-extract-plugin
var _1 = "TopicPostSection-module__animateUploadProgressBarWidth--Av9Bl";
var _2 = "TopicPostSection-module__animatedBackground--rIq1d";
var _3 = "TopicPostSection-module__buttonText--yNc6t";
var _4 = "TopicPostSection-module__posts--luPxg";
var _5 = "TopicPostSection-module__showMoreButton--iVgzO";
var _6 = "TopicPostSection-module__simplePosts--nsc6y";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "buttonText", _4 as "posts", _5 as "showMoreButton", _6 as "simplePosts" }
